class BlockControler {

  //
  //  BlockControler Documentatie
  //
  //  Is een variant op de ArchiveController
  //  Registreer het block in een loop
  //  Zorg dat je de filters en input van het block juist koppeld
  //  Dit gaat allemaal via #block_id en .classes
  //  Denk aan "block-items__filter filter_1, block-items__search, block-items__container, block-items__more-button"
  //  Voorbeeld : personitems block
  //

  constructor() {
    this.version = 1.1;               // versiebeheer van script
    this.ajax_url = false;            // URL waar calls naar toe gaan
                                      // Kan handmatig of via archive_container data-ajaxurl="permalink"
    this.self_loading = false;        // zelf bezig

    // this.filters_checkboxgroup = [];  // element (met meerder checkbox-opties en data-param="parameter naam")
    this.filters_select = [];         // element (met 1 keuze optie en data-param="parameter naam")
    this.search_input = null;         // element

    this.block = null;
    this.block_items_container = null;    // ajax vervangt innerHTML
    this.block_items_observer = null;     // monitor innerHTML

    this.filter_timer = null;
    this.callbacks = {
      'change' : null
    };
  }

  // Config

  set_ajax_url( _url ) {
    this.ajax_url = _url;
  }

  register_filter_select( _el ) {
    if( _el == null ) return;
    if( !_el.hasAttribute('data-param') ) { console.log('filter mist parameter'); return; }
    _el.addEventListener('change', this.update_filters.bind(this));
    this.filters_select.push(_el);
  }

  register_search_input( _el ) {
    if( _el == null ) return;
    if( 'onsearch' in _el ) {
      _el.addEventListener('search', this.update_search.bind(this));
    } else {
      _el.addEventListener('keydown', this.update_search_on_enter.bind(this));
    }
    this.search_input = _el;
  }

  register_block( _el ) {
    if( _el == null ) return;
    if( !this.ajax_url && _el.hasAttribute('data-ajaxurl') ) {
      this.ajax_url = _el.getAttribute('data-ajaxurl');
    }

    this.block = _el;
    this.block_items_container = _el.querySelector('.block-items__container');
    this.block_items_observer = new MutationObserver( this.block_items_changed.bind(this) );
    this.block_items_observer.observe( this.block_items_container, { 
      childList: true,
      subtree: false // indien noodzakelijk true, default false 
    });

  }

  on( _eventname, _callback_function ) {
    if( !(typeof _callback_function == 'function') ) { console.log('callback mist functie'); return; }
    if( !this.callbacks.hasOwnProperty(_eventname )){ console.log('onbekend event voor callback'); return; }
    this.callbacks[_eventname] = _callback_function;
  }

  set_more_button() {
    if( this.block_items_container ) {
      const more_btn = this.block_items_container.querySelector('.block-items__more-button');
      if( more_btn ) {
        more_btn.addEventListener( 'click', this.update_more.bind(this) );
      }
    }
  }

  // Filter timer (delay on mulitselect filter)
  start_filter_timer() {
    if( this.filter_timer !== null ) clearTimeout(this.filter_timer);
    var self = this;
    this.filter_timer = setTimeout( function() {
      self.update_archive(1);
    }, 1000);
  }

  // Loading

  start_loading() {
    this.self_loading = true;

    this.filters_select.forEach( filter => filter.disabled = true );
    if( this.search_input ) this.search_input.readOnly = true;

    if( !this.block.classList.contains('block-loading') )
      this.block.classList.add('block-loading');
  }

  stop_loading() {
    this.self_loading = false;

    this.filters_select.forEach( filter => filter.disabled = false );
    if( this.search_input ) this.search_input.readOnly = false;

    if( this.block.classList.contains('block-loading'))
      this.block.classList.remove('block-loading');
  }

  // Input Events

  block_items_changed() {
    this.set_more_button();
    if( typeof this.callbacks['change'] === 'function' )
      this.callbacks['change'](this); // callback
  }

  update_filters( e ) {
    e.preventDefault();
    this.update_archive(1);
  }

  update_search() {
    this.update_archive(1);
  }

  update_more( e ) {
    if( ['BUTTON','SPAN'].includes(e.target.tagName) ) {
      if( !e.target.hasAttribute('data-page') ) { console.log('more-button mist parameter'); return; }
      this.update_archive(e.target.getAttribute('data-page'));
    }
  }

  // Ajax

  update_archive(page) {
    if( this.self_loading ) { console.log('still loading ...'); return; }
    if( this.ajax_url == false ) { console.log('no ajax url'); return; }
    if( this.block_items_container == null ) { console.log('empty archive container'); return; }

    const self = this;
    self.start_loading();

    // querystring

    var data = {};

    self.filters_select.forEach( filter => {
      const display = !(window.getComputedStyle(filter, null).display == 'none'); 
      const param_name = filter.getAttribute('data-param');
      const param_value = filter.value;

      if( display && param_value ) {
        data[param_name] = param_value;
      }
    });

    if( self.search_input && self.search_input.value ) {
      data['srch'] = self.search_input.value;
    }

    data['paging'] = page; // default 1

    const querystring = new URLSearchParams(data).toString();
    const glue = self.ajax_url.includes('?') ? '&' : '?';
    const complete_ajax_url =  self.ajax_url + glue + querystring;

    // ajax-call

    try {
      jQuery.get(complete_ajax_url, function (data) {
        try {
          // Default Ajax afhandeling
          const parser = new DOMParser();
          const htmlDoc = parser.parseFromString(data, "text/html");
          const newBlock = htmlDoc.getElementById( self.block.id );
          if( newBlock ) {
            const newContent = newBlock.querySelector( '.block-items__container');
            if( page == 1 ) {
              self.block_items_container.innerHTML = newContent.innerHTML;
            } else {
              const more_btn = self.block_items_container.querySelector('.block-items__more-button');
              if( more_btn ) more_btn.remove();
              self.block_items_container.innerHTML += newContent.innerHTML;
            }
          }
          // handle button-events via mutationobserver
        } catch (e) {
          console.log(e);
        }
      })
        .fail(function (jqXHR, textStatus, errorThrown) {
          console.log(jqXHR);
          console.log(textStatus);
          console.log(errorThrown);
        })
        .always(function () {
          self.stop_loading();
        });
    } catch (e) {
      self.stop_loading();
    }

  }

}